
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Show = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <title>Show</title>
        <g stroke="none" fill="none" className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M12.51216,5 C17.6421142,5 21.731423,7.29722987 24.7031506,11.8392545 L25,12.2929628 L24.7019821,12.7458596 C21.7139551,17.2867547 17.6171883,19.5833333 12.48784,19.5833333 C7.3578858,19.5833333 3.26857703,17.2861035 0.296849421,12.7440788 L0,12.2903705 L0.298017855,11.8374738 C3.28604494,7.2965786 7.38281166,5 12.51216,5 Z M12.51216,6.62037037 C8.08473126,6.62037037 4.57327939,8.49569339 1.9099024,12.2929359 C4.55821821,16.0885339 8.06133762,17.962963 12.48784,17.962963 C16.9152687,17.962963 20.4267206,16.0876399 23.0900976,12.2903974 C20.4417818,8.49479942 16.9386624,6.62037037 12.51216,6.62037037 Z M12.5,8.24074074 C14.6745973,8.24074074 16.4374567,10.0544021 16.4374567,12.2916667 C16.4374567,14.5289313 14.6745973,16.3425926 12.5,16.3425926 C10.3254027,16.3425926 8.56254328,14.5289313 8.56254328,12.2916667 C8.56254328,10.0544021 10.3254027,8.24074074 12.5,8.24074074 Z M12.5,9.86111111 C11.1952416,9.86111111 10.137526,10.9493079 10.137526,12.2916667 C10.137526,13.6340254 11.1952416,14.7222222 12.5,14.7222222 C13.8047584,14.7222222 14.862474,13.6340254 14.862474,12.2916667 C14.862474,10.9493079 13.8047584,9.86111111 12.5,9.86111111 Z"></path>
        </g>
      </g>
    </IconBase>);
};

Show.defaultProps = {
  title: 'Show',
};

export default Show;
